import '../storefront/javascripts/index.js';
import '../storefront/stylesheets/index.js';

var componentRequireContext = require.context("components/accounts", true)
var ReactRailsUJS = require("react_ujs")
ReactRailsUJS.useContext(componentRequireContext)
ReactRailsUJS.mountComponents()
